<ng-template
  #optionTemplate
  let-flagSize="flagSize"
  let-hideName="hideName"
  let-index="index"
  let-item$="item$"
  let-search="search"
  let-showEndSelectedIcon="showEndSelectedIcon">
  <div
    class="bn-select__container__dropdown__item d-flex justify-content-between {{ item$.value?.sticky ? 'sticky-item' : '' }}"
    [attr.aria-label]="item$.value?.tooltip || item$.label"
    [attr.title]="null">
    @if (!hideName && (item$.label || item$.value.country)) {
      <div class="ng-value-label bn-select__container__dropdown__item__text align-self-start d-flex align-items-center">
        <div
          container="body"
          containerClass="m-2"
          placement="right"
          [tooltip]="item$.value?.tooltip">
          <ng-template *ngTemplateOutlet="flag; context: { $implicit: item$.value.country, size: flagSize }" />
          <span [innerHTML]="hideName ? '' : (item$.label | MarkSearchString: search)"></span>
          @if (item$.value?.indicator) {
            <ng-template *ngTemplateOutlet="indicatorTemplate.indicatorTemplate(); context: { $implicit: item$.value.indicator }" />
          }
        </div>
      </div>
    }
    <!-- BADGES -->
    @if (item$.value?.badges) {
      <div class="align-self-end">
        @for (badge of item$.value.badges; track $index) {
          <bn-web-ui-badge
            containerClass="m-2"
            placement="right"
            [color]="badge?.context"
            [contentClass]="item$.value.badges.length - 1 !== $index ? 'me-2' : ''"
            [size]="badge?.size"
            [tooltip]="badge?.tooltip"
            [type]="badge?.badgeType">
            @if (badge?.icon) {
              <fa-icon [icon]="badge.icon" />
            }
            {{ badge.text }}
          </bn-web-ui-badge>
        }
      </div>
    }
    @if (showEndSelectedIcon) {
      <div class="bn-select__container__dropdown__item__icon align-self-end ms-2">
        <fa-icon icon="check" />
      </div>
    }
  </div>
</ng-template>

<!-- FLAG -->
<ng-template
  #flag
  let-country
  let-size="size">
  @if (country) {
    <bn-web-ui-flag
      class="d-inline-block me-1"
      [country]="country"
      [showTooltip]="false"
      [size]="size" />
  }
</ng-template>

<bn-web-ui-indicator-select-template #indicatorTemplate />
